import { Dispatch, FC, ReactNode, SetStateAction } from 'react';
import { optionModal } from './Modal/StudentLearnExperienceModal';

interface Props {
  data: {
    title: ReactNode;
    subtitle: string;
    img: string;
    color: string;
    letter: string;
  };
  setOption: Dispatch<SetStateAction<optionModal>>;
  setVisible: Dispatch<SetStateAction<boolean>>;
}

const BADGE_COLORS: Record<string, string> = {
  A: 'tw-bg-indigo-700',
  B: 'tw-bg-purple-700',
  C: 'tw-bg-sky-700',
};

const StudentLearnExperienceCard: FC<Props> = ({ data, setOption, setVisible }) => {
  return (
    <button
      className="nc_student-learn-experience-card tw-relative tw-text-left"
      onClick={() => {
        if (data.letter === 'A') setOption(optionModal.FIRST);
        if (data.letter === 'B') setOption(optionModal.SECOND);
        if (data.letter === 'C') setOption(optionModal.THIRD);
        setVisible(true);
      }}
    >
      {/* Colored letter badge over the top border */}
      <span
        className={`tw-absolute -tw-top-4 tw-left-5 tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-lg tw-text-sm tw-font-bold tw-font-sora tw-text-white tw-rotate-[350deg] ${
          BADGE_COLORS[data.letter] ?? 'tw-bg-neutral-700'
        }`}
      >
        {data.letter}
      </span>

      {/* Connector between cards */}
      {data.letter !== 'C' && (
        <span className="tw-absolute tw-left-full tw-top-1/5 tw-z-10 tw-flex -tw-translate-y-1/2 tw-items-center">
          <span className="tw-h-[15px] tw-w-[15px] tw-rounded-full tw-bg-stone-400 tw-absolute tw-left-[17px]" />
          <span className="tw-h-[15px] tw-w-[47px] tw-bg-stone-200" />
        </span>
      )}

      <h1 className="tw-text-lg tw-font-atkinson tw-font-bold tw-text-stone-800 tw-m-0">{data.title}</h1>
      <p className="tw-text-sm tw-font-atkinson tw-text-stone-600 tw-m-0">{data.subtitle}</p>
      <div className="tw-mt-auto tw-w-full tw-rounded-xl tw-border tw-border-solid tw-border-stone-200 tw-bg-stone-50 tw-p-3">
        <img src={data.img} alt={data.img} className="tw-h-40 tw-w-full tw-object-contain" />
      </div>
    </button>
  );
};

export default StudentLearnExperienceCard;
